module.exports = __webpack_public_path__ + "media/images/sections/home/bride-4f6af7be4d06f869e91c8a76e050d1d7.png";